import {
  EmailMsgTemplateConfig,
  EmailMsgTemplateSearchField,
  EmailMsgTemplateColumn,
} from './email-msg-template.types';

export const EMAIL_MSG_TEMPLATE_SEARCH_FIELDS: EmailMsgTemplateSearchField[] = [
  {
    name: 'msgTemplateNm',
    type: 'text',
    label: 'REPO.TABLE.emailMsgTemplate.msgTemplateNm',
  },
  {
    name: 'msgRuleType',
    type: 'select',
    label: 'REPO.TABLE.emailMsgTemplate.msgRuleType',
    options: [
      {
        value: 'DOCUMENT',
        label: 'REPO.TABLE.emailMsgTemplate.msgRuleType.DOCUMENT',
      },
    ],
  },
  {
    name: 'msgType',
    type: 'select',
    label: 'REPO.TABLE.emailMsgTemplate.msgType',
    options: [
      { value: 'EMAIL', label: 'REPO.TABLE.emailMsgTemplate.msgType.EMAIL' },
    ],
  },
  {
    name: 'msgSj',
    type: 'text',
    label: 'REPO.TABLE.emailMsgTemplate.msgSj',
  },
  {
    name: 'activeFl',
    type: 'select',
    label: 'REPO.TABLE.emailMsgTemplate.activeFl',
    options: [
      { value: 'true', label: 'Use' },
      { value: 'false', label: 'UnUse' },
    ],
  },
];

export const EMAIL_MSG_TEMPLATE_COLUMNS: EmailMsgTemplateColumn[] = [
  {
    key: 'id',
    name: 'REPO.TABLE.emailMsgTemplate.id',
    type: 'number',
    width: '70px',
    class: 'text-center',
    sortable: true,
  },
  {
    key: 'msgTemplateNm',
    name: 'REPO.TABLE.emailMsgTemplate.msgTemplateNm',
    type: 'text',
    sortable: true,
  },
  {
    key: 'msgRuleType',
    name: 'REPO.TABLE.emailMsgTemplate.msgRuleType',
    type: 'text',
  },
  {
    key: 'msgType',
    name: 'REPO.TABLE.emailMsgTemplate.msgType',
    type: 'text',
  },
  {
    key: 'msgSj',
    name: 'REPO.TABLE.emailMsgTemplate.msgSj',
    type: 'text',
  },
  {
    key: 'activeFl',
    name: 'REPO.TABLE.emailMsgTemplate.activeFl',
    type: 'text',
    translate: true,
    valueFn: ({ activeFl }) => (activeFl ? 'Use' : 'UnUse'),
  },
];

export const EMAIL_MSG_TEMPLATE_CONFIG: EmailMsgTemplateConfig = {
  title: 'brandFn.menu.emailMsgTemplate',
  viewType: 'table',
  searchFields: EMAIL_MSG_TEMPLATE_SEARCH_FIELDS,
  columns: EMAIL_MSG_TEMPLATE_COLUMNS,
  defaultPageSize: 5,
  defaultSort: 'id,desc',
  routePath: 'master/email-msg-template',
};
